<template>
<div class="row">
  <div class="col-sm-12">

    <div class="row" style='margin-top:25px'>
      <div class="col-sm-12">
        <div class="form-group">
            <div class="za-label">Titre *</div>
            <div :class="{za_editbox: showedit}" v-if="readmode.name" v-on:click="editMode('name')">{{service.name}}</div>
            <span v-show="!readmode.name">
              <input ref='name' class="form-control" v-model="service.name" autofocus>
              <label class="error" v-if="errors.name">{{ errors.name }}</label>
              <div style="margin-top:5px">
                <button type="button" class="btn btn-primary btn-sm" v-on:click="save()"><i class="fas fa-save" aria-hidden="true"></i> Enregistrer</button>
                <button type="button" class="btn btn-link btn-sm" v-on:click="cancelEditMode('name')">Annuler</button>
              </div>
            </span>
          </div>
      </div>
    </div>

      <div class="za-label">Dossier
        <a class="za-label-action" v-on:click="editMode('dossier')"><i class="fas fa-plus fa-spacer" aria-hidden="true"></i>Ajouter</a>
      </div>

      <div class="row" style='margin-top:25px' v-show="!readmode.dossier">
        <div class="col-sm-6">
          <div class="form-group">
            <select ref="dossier" v-model="dossier_id" class="form-control">
              <option value="" selected>Choisir</option>
              <option v-for="option in dossiers" v-bind:value="option.dossier_id" v-bind:key="option.dossier_id">
                {{ option.dossier_name}}
              </option>
            </select>
            <label class="error" v-if="errors.dossier">{{ errors.dossier }}</label>
          </div>
        </div>
        <div class="col-sm-12" style="margin-top:10px">
          <button type="button" class="btn btn-primary btn-sm" v-on:click="save_dossier"><i class="fas fa-save" aria-hidden="true"></i> Enregistrer</button>
          <button type="button" class="btn btn-link btn-sm" v-on:click="cancelEditMode('dossier')">Annuler</button>
        </div>
      </div>

      <div class="row" style='margin-top:10px'>
        <div class="col-sm-12">
          <div v-for="dossier in service_dossiers" :key="dossier.dossier_id">
            <div class="app_row row">
                <div class=" col-sm-11" @click="$router.push({ name: 'dossier', params: { designation_dossier_id: dossier.dossier_id }})">
                  {{dossier.dossier_name}}
                  <small class="text-muted" v-if="dossier.status_name || dossier.dossier_type_key === 'renew' || dossier.dossier_type_key === 'fusion'">
                    ({{ dossier.status_name }}<template v-if="dossier.dossier_type_key === 'renew' || dossier.dossier_type_key === 'fusion'"><template v-if="dossier.status_name">, </template>type {{ dossier.dossier_type_name }}</template>)
                  </small>
                </div>
                <div class="col-sm-1"><a v-on:click="confirm_delete_dossier(dossier.dossier_id)" style="cursor:pointer"><em class="fas fa-trash-alt" aria-hidden="true"></em></a></div>
            </div>
          </div>
        </div>

      </div>
      
      <ListDocuments :parent-id="$route.params.service_id" parent-type="service" :service-provider-id="$route.params.service_provider_id"></ListDocuments>

    <div class="row" style='margin-top:25px;margin-bottom:25px'>
      <div class="col-sm-12">
        <div class="form-group">
            <div class="za-label">Statut</div>
            <div v-if="service">
              <span v-if="service.status">
                {{ service.status }}
              </span>
              <span v-else>
                Aucun statut spécifié
              </span> 
              <small class="text-muted">(déduit du statut des dossiers)</small>
            </div>
        </div>
      </div>
    </div>

    <div class="row" style='margin-top:25px;margin-bottom:25px'>
      <div class="col-sm-12">
        <div class="form-group">
            <div class="za-label">Description</div>
            <div :class="{za_editbox: showedit}" v-if="readmode.description" v-on:click="editMode('description')">
                <em v-if="!service.description" class="text-muted">Entrer une description...</em>
                <div v-html="service.description"></div>
            </div>
            <span v-show="!readmode.description">
              <trumbowyg :config="config" style="height:100px" class="form-control" v-model="service.description"></trumbowyg>
              <label class="error" v-if="errors.description">{{ errors.description }}</label>
              <div style="margin-top:5px">
                <button type="button" class="btn btn-primary btn-sm" v-on:click="save()"><i class="fas fa-save" aria-hidden="true"></i> Enregistrer</button>
                <button type="button" class="btn btn-link btn-sm" v-on:click="cancelEditMode('description')">Annuler</button>
              </div>
            </span>
          </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-sm-12">
        <button class="btn btn-default" v-on:click="back" >Retour</button>
      </div>
    </div>
  </div>

  <transition name="modal" >
        <div class="modal-mask" v-show="show_confirm_dossier">
            <div class="modal-block modal-block">
              <section class="panel">
                <header class="panel-heading">
                    <strong>Êtes-vous certain?</strong>
                </header>
                <div class="panel-body">
                  <div class="modal-wrapper">
                    <div class="modal-text">
                      <p>Êtes-vous certain de vouloir supprimer ce dossier?</p>
                    </div>
                  </div>
                </div>
                <footer class="panel-footer">
                  <div class="row">
                    <div class="col-md-12 text-right">
                      <a class="btn btn-default" v-on:click="cancel_delete_dossier">Non</a>&nbsp;&nbsp;<a class="btn btn-default" v-on:click="delete_dossier">Oui</a>
                    </div>
                  </div>
                </footer>
              </section>
            </div>
        </div>
      </transition>
</div>
</template>

<script>
import ListDocuments from '@/components/ListDocuments.vue'

import axios from 'axios';

import {en, fr} from 'vuejs-datepicker/dist/locale';

export default {
  data: function() {return {
    service_id:0,
    serviceprovider:{},
    service:{},
    errors:{name:'',description:'',dossier:''},
    messages:{},
    service_dossiers:[],
    show_confirm_dossier:false,
    showedit:true,
    dossiers:{},
    dossier_id:'',
    readmode: {
      dossier: true,
      name:true,
      description:true,
    },
    field_backup: null,
    fr:fr,
    en:en,
    config: this.$trumbowygConfig,

  }},
  components: {
    ListDocuments
  },
  methods: {

    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/service_provider_service.php',
          { params: {service_id:this.$route.params.service_id,service_provider_id: this.$route.params.service_provider_id}})
        .then(response => {
          this.$checkApiErrors(response.data)
          this.serviceprovider = response.data.serviceprovider
          this.service = response.data.service
          this.dossiers = response.data.dossiers
          this.service_dossiers = response.data.service_dossiers}
        )
        .then(() => {
          axios.get(this.$root.$data.server_base + '/api/service_provider_dossiers_statuses.php',
            { params: {dossier_ids:this.service_dossiers.map(dossier => dossier.dossier_id )}}
          ).then(response => {
            var service_dossiers = []
            this.service_dossiers.forEach(dossier => {
              dossier.status_name = response.data.dossier_statuses[dossier.dossier_id]['status_name']
              service_dossiers.push(dossier)
            })
            this.service_dossiers = service_dossiers
          })
        })
    },
    back: function()
    {
      this.$router.go(-1);
    },

    save: function()
    {
      var empty_field = false;

      if(this.service.name == '')
      {
        this.errors.name = this.messages.required;
        empty_field = true;
      }
      else
        this.errors.name = '';

      
      if(!empty_field)
      {
        let data = {
          service_id: this.service_id,
          name: this.service.name,
          description: this.service.description,
          service_provider_id:this.$route.params.service_provider_id

        }
        axios
          .post(this.$root.$data.server_base + '/api/service_save.php',
            data,
            {headers:{
                'Content-Type': 'application/json',
          }})

          .then(response => {
            this.$checkApiErrors(response.data);
            this.readmode.name=true,
            this.readmode.description=true
          })

      }
    },

    save_dossier: function()
    {
      var empty_field = false;

      if(this.dossier_id == '')
      {
        this.errors.dossier = this.$messages.required;
        empty_field = true;
      }
      else
        this.errors.dossier = '';

      if(!empty_field)
      {
        var data = {
          dossier_id:this.dossier_id,
          service_provider_id:this.$route.params.service_provider_id,
          service_id:this.$route.params.service_id,
        }
        axios
          .post(this.$root.$data.server_base + '/api/service_dossier_save.php',
            data,
            {headers:{
                'Content-Type': 'application/json',
          }})
          .then(response => {
            this.readmode.dossier=true;
            this.dossier_id='';
            this.refresh();
          })
      }
    },
    confirm_delete_dossier: function(dossier_id)
    {
        this.show_confirm_dossier=true;
        this.dossier_id=dossier_id;
    },

    cancel_delete_dossier: function()
    {
      this.show_confirm_dossier=false;
      this.dossier_id='';
    },
    
    delete_dossier: function()
    {
      var data = {
        service_id:this.$route.params.service_id,
        dossier_id:this.dossier_id
      }
      
      axios
          .post(this.$root.$data.server_base + '/api/delete_service_dossier.php',
            data,
            {headers:{
                'Content-Type': 'application/json',
          }})
          .then(response => {
            this.show_confirm_dossier=false;
            this.service_id='';
            this.refresh();
          })
    },

    editMode: function(field)
    {
      //if(!this.showedit) return;

      for (let [key, value] of Object.entries(this.readmode)) {
        if(key != field && value==false) {
          // Warn only if value changed
          if(this.dossier[key]!=this.field_backup) {
            this.errors[key]="Sauvegardez ou annulez les changements avant de passer à un autre champ";
            return;
          }
          else {
            this.cancelEditMode(key);
          }
        }
      }
      this.readmode[field] = false;
      this.field_backup = this.service[field];
      this.$nextTick(() => {if(this.$refs[field]) this.$refs[field].focus();})
    },

    cancelEditMode: function(field)
    {
      this.readmode[field] = true;
      this.service[field] = this.field_backup;
      this.errors[field] = "";

      if(field=="dossier") {
        this.dossier='';
      }
    },

  },
  mounted () {
    if(this.$route.params.service_id)
      this.service_id=this.$route.params.service_id;
    this.refresh();
    this.messages = this.$root.$data.messages;

  }
}
</script>
